import React from "react";

import { Flex } from "../Flex";
import { Text } from "../Text";

import styles from "./SystemInfoButton.scss";

/**
 * Props for the SystemInfoButton component.
 */
export interface SystemInfoButtonProps {
  /**
   * Text component or string used in the left side of the button
   */
  infoText: React.ReactNode | string;
  /**
   * Action button that triggers something
   */
  actionButton: React.ReactNode;
}

/**
 * A container for showing highlighted info and trigger certain action related.
 */
export function SystemInfoButton({
  infoText,
  actionButton,
}: SystemInfoButtonProps): JSX.Element {
  return (
    <Flex className={styles["container"]}>
      <Flex>
        {typeof infoText === "string" ? (
          <Text data-testid="system-info-button-text">{infoText}</Text>
        ) : (
          infoText
        )}
      </Flex>
      {actionButton}
    </Flex>
  );
}
